import * as React from "react";
import {Autocomplete,TextField } from "@mui/material";
import { useLebels } from "../../../../../../utils/reactQuery/boards";
import { createAndUpdateLabel } from "../../../../../../sevices/apiCards";
import {  useQueryClient } from "@tanstack/react-query";
import useToastPromise from "../../../../../../hooks/useToast";
import useMutate from "../../../../../../hooks/useMutate";

export default function ComboBox({
  labels,
  boardId,
  cardId,
  setShowLebel,
}) {
  const [inputValue, setInputValue] = React.useState("");
  const [selectedLabels, setSelectedLabels] = React.useState(labels.map((item) => item.label));
  const [prevLabels, setPrevLabels] = React.useState([...selectedLabels]);

  const queryClient = useQueryClient();
  const { isLoading, error, lebels: lebelsOpt } = useLebels(boardId);
  const { showToastPromise } = useToastPromise();
  const [isError, setIsError] = React.useState(false)
  const options = lebelsOpt?.data?.data?.responseData.map((item) => item.label) || [];

  const { mutate: createAndUpdateLabelMutate } = useMutate(createAndUpdateLabel,[`mineCards`,`watching`],
    ()=>{},
    () => {
      
      queryClient.invalidateQueries({
        queryKey: [`card`, Number(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: [`card`, cardId],
      });
      
      queryClient.invalidateQueries({
        queryKey: [`cards`, boardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`lebels`, boardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`cards`, boardId.toString()],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, Number(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: [`mineCards`],
      });queryClient.invalidateQueries({
        queryKey: [`userCards`],
      });queryClient.invalidateQueries({
        queryKey: [`assignedCards`],
      });
      queryClient.invalidateQueries({
        queryKey: [`watching`],
      });
      // setLoading(false);
      // console.log(res);
      //    reset();
      //toast.success(res.data.message);
      setShowLebel(false);
    },
    ()=>{},
  );


  // Function to add new label on Enter or Blur
  const handleLabelSubmission = () => {
    if (inputValue.trim() !== "") {
      setSelectedLabels((prevLabels) => {
        const updatedLabels = [...new Set([...prevLabels, inputValue.trim()])]; // Remove duplicates
        setInputValue(""); // Clear input field
        return updatedLabels;
      });
    }

    const uniqueLabels = [...new Set(selectedLabels)];

    // Make API call with selected labels
    if (JSON.stringify(prevLabels) !== JSON.stringify(selectedLabels)) {
      createAndUpdateLabelMutate({
        card_id: cardId,
        data: { labels: [...uniqueLabels] },
      });

      setShowLebel(false);
      // Update previous labels after API call
      setPrevLabels([...uniqueLabels]);
    }
  };

  const handleInputChange = (event, newInputValue) => {
    const uniqueLabels = [...new Set(newInputValue)]; // Remove duplicates
    setSelectedLabels(uniqueLabels);
  };

  const enterCallback = (event) => {
    if (event.key === "Enter" && !isError) {
      event.preventDefault(); // Prevent form submission
      handleLabelSubmission();
    }
  };

  React.useEffect(() => {
    handleLabelSubmission()
  }, [selectedLabels])

  const handleBlur = (e) => {
    if (!isError) {
      handleLabelSubmission();
    }
    setTimeout(() => {
      setShowLebel(false);
    }, 300)
  };

  const handleChange = (event, newInputValue) => {
    if (newInputValue?.length > 30) {
      setIsError(true);
    } else {
      setIsError(false);
      setInputValue(newInputValue);
    }
  };

  return (
    <Autocomplete
      multiple
      autoFocus
      options={options}
      value={selectedLabels}
      inputValue={inputValue}
      onChange={handleInputChange}
      onInputChange={handleChange}
      onKeyDown={enterCallback}
      onBlur={handleBlur}
      id="size-small-outlined-multi"
      size="small"
      disablePortal
      sx={{
        width: "100%",
        height: "32px",
        marginRight: "0px",
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              autoFocus: true,
            }}
            error={!!isError}
            helperText={isError && "Max. limit 30 characters"}
            className="label-search-input"
            sx={{
              "& .MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-16px", // Moves error below the field
                background: "white", // Prevents overlay issues
                zIndex: 1301, // Ensures it's above the dropdown
              },
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                zIndex: 999,
              },
            }}
          />
        );
      }}
    />
  );
}